import { gql, useMutation } from '@apollo/client';

const useDeleteFailedSchedule = () => {
  const [__deleteFailedSchedule] = useMutation(MUTATION, {
    refetchQueries: [
      'scheduledDeployment',
      'getPendingDeployment'
    ]
  });
  const deleteFailedSchedule = (_id) => __deleteFailedSchedule({
    variables: { _id }
  });

  return {
    deleteFailedSchedule
  };
};

const MUTATION = gql`
mutation deleteFailedSchedule($_id: String!) {
  deleteFailedSchedule(_id: $_id) {
    _id
    deployAt
    version
    bucketName
    state
    deleted
  }
}
`;

export default useDeleteFailedSchedule;
